import { useEffect, useState } from 'react';

const useSessionStorage = <T>(
  key: string,
  initialValue: T,
): [T, (value: T) => void, () => void] => {
  const [storedValue, setStoredValue] = useState(initialValue);

  useEffect(() => {
    if (!window.sessionStorage) return;
    // Retrieve from local storage
    const item = window.sessionStorage.getItem(key);
    if (item) {
      setStoredValue(JSON.parse(item));
    }
  }, [key]);

  const setValue = (value: T) => {
    setStoredValue(value);
    window.sessionStorage.setItem(key, JSON.stringify(value));
  };

  const removeValue = () => {
    window.sessionStorage.removeItem(key);
  };

  return [storedValue, setValue, removeValue];
};

export default useSessionStorage;
